"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StatsQueriesTypes;
(function (StatsQueriesTypes) {
    StatsQueriesTypes[StatsQueriesTypes["ALL_QUERIES"] = 0] = "ALL_QUERIES";
    StatsQueriesTypes[StatsQueriesTypes["QUERIES_WITH_RESULTS"] = 1] = "QUERIES_WITH_RESULTS";
    StatsQueriesTypes[StatsQueriesTypes["QUERIES_WITHOUT_RESULTS"] = 2] = "QUERIES_WITHOUT_RESULTS";
})(StatsQueriesTypes = exports.StatsQueriesTypes || (exports.StatsQueriesTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHMtcXVlcmllcy10eXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9zdGF0cy1xdWVyaWVzLXR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBWSxpQkFJWDtBQUpELFdBQVksaUJBQWlCO0lBQzNCLHVFQUFlLENBQUE7SUFDZix5RkFBd0IsQ0FBQTtJQUN4QiwrRkFBMkIsQ0FBQTtBQUM3QixDQUFDLEVBSlcsaUJBQWlCLEdBQWpCLHlCQUFpQixLQUFqQix5QkFBaUIsUUFJNUIifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@empathybroker/tsclient-stats/dist/enums/stats-queries-types.js
// module id = 0tAl
// module chunks = 0